import { Component } from '@angular/core';
import { TranslationPipe } from '@cloud-and-service/portal-lib';

@Component({
    selector: 'app-admin-log-list',
    templateUrl: './admin-log-list.component.html',
    styleUrls: ['./admin-log-list.component.scss'],
    imports: [TranslationPipe],
})
export class AdminLogListComponent {

  constructor() { }

  throwError() {
    throw Error("The app component has thrown an error!");

  }
}
